import { Controller } from "@hotwired/stimulus";
import displayToastMessage from "../utils/display_toast_message";

export default class extends Controller {
  static values = {
    text: String,
    icon: String,
  };

  connect() {
    this.hideNoJSFallback();
    this.displayToast();
  }

  hideNoJSFallback() {
    this.element.classList.add("u-hidden");
  }

  displayToast() {
    const { textValue: text, iconValue: icon } = this;
    displayToastMessage({ text, icon });
  }
}
